export default __webpack_public_path__ + "a593b6dd325c3b26a3b28bc52220e2b5.png";